import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/infopages.scss";

function Delivery() {
  return (
    <div className="delivery">
      <Header />
      <main id="maincontent" className="page-main">
        <div className="page-title-wrapper"><h1 className="page-title"><span className="base">Shipping Information</span></h1></div>
        <div className="columns"><div className="column main">
          <p>hetcratehub aims to provide clear delivery choices and careful packing for every order.</p>

          <h4>Available services</h4>
          <p>The delivery methods, prices, and estimated timeframes available for your address are shown at checkout. Service availability can vary by destination, parcel size, product restrictions, weather, and carrier capacity.</p>

          <h4>Processing and estimates</h4>
          <p>Orders are normally prepared on business days. Delivery dates are estimates unless we expressly confirm a guaranteed service. You will receive available tracking details after the parcel is handed to the carrier.</p>

          <h4>Address checks</h4>
          <p>Please review the delivery address before submitting an order. Contact us immediately if it is incorrect. We will try to help, but changes may not be possible after fulfilment begins and redirection fees may apply.</p>

          <h4>Restricted or oversized items</h4>
          <p>Some destinations and products may require a different service or additional charge. If checkout cannot quote delivery, email us before ordering so we can confirm the options available.</p>

          <h4>Delays, loss, or damage</h4>
          <p>If tracking stops updating, the parcel arrives damaged, or it is marked delivered but cannot be located, check the delivery area and contact us promptly. Keep all packaging and provide photographs for a damage claim.</p>

          <h4>Questions</h4>
          <p>Email <a href="mailto:group@hetcratehub.today">group@hetcratehub.today</a> with the destination postcode and product details. We will help identify the available delivery service.</p>
        </div></div>
      </main>
      <Footer />
    </div>
  );
}

export default Delivery;
